import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    const message = error.response?.data?.message || error.message || 'Network error';
    return Promise.reject(new Error(message));
  }
);

export const login = (data) => api.post('/auth/login', data);
export const register = (data) => api.post('/auth/register', data);
export const getMe = () => api.get('/auth/me');

export const updateProfile = (data, avatarFile) => {
  const formData = new FormData();
  if (data.nickname != null) formData.append('nickname', data.nickname);
  if (data.bio != null) formData.append('bio', data.bio);
  if (data.website != null) formData.append('website', data.website);
  if (avatarFile) formData.append('avatarFile', avatarFile);
  return api.put('/users/profile', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const changePassword = (data) => api.put('/users/password', data);
export const getUserProfile = (id) => api.get(`/users/${id}/profile`);
export const recordProfileView = (id) => api.post(`/users/${id}/profile-view`);

export const getArticles = (params) => api.get('/articles', { params });
export const getArticle = (id) => api.get(`/articles/${id}`);
export const createArticle = (data) => api.post('/articles', data);
export const updateArticle = (id, data) => api.put(`/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/articles/${id}`);
export const toggleLike = (id) => api.post(`/articles/${id}/like`);
export const getArticlesByUser = (userId, params) => api.get(`/articles/user/${userId}`, { params });
export const getArticlesByCategory = (categoryId, params) => api.get(`/articles/category/${categoryId}`, { params });
export const getArticlesByTag = (tagId, params) => api.get(`/articles/tag/${tagId}`, { params });

export const searchArticles = (params) => api.get('/search', { params });

export const getComments = (articleId, params) => api.get(`/comments/article/${articleId}`, { params });
export const createComment = (data) => api.post('/comments', data);
export const deleteComment = (id) => api.delete(`/comments/${id}`);

export const getCategories = () => api.get('/categories');
export const createCategory = (params) => api.post('/categories', null, { params });
export const updateCategory = (id, params) => api.put(`/categories/${id}`, null, { params });
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

export const getTags = () => api.get('/tags');
export const deleteTag = (id) => api.delete(`/tags/${id}`);

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getPublicStats = () => api.get('/statistics/public');
export const recordPageView = () => api.post('/statistics/page-view');
export const getMyStats = () => api.get('/statistics/my');

export const getNotifications = (params) => api.get('/notifications', { params });
export const getUnreadCount = () => api.get('/notifications/unread-count');
export const markAllNotificationsRead = () => api.put('/notifications/read-all');

export const getAdminStats = () => api.get('/admin/statistics');
export const getAdminUsers = (params) => api.get('/admin/users', { params });
export const toggleUserEnabled = (id) => api.put(`/admin/users/${id}/toggle`);
export const getAdminArticles = (params) => api.get('/admin/articles', { params });
export const adminUpdateArticle = (id, data) => api.put(`/admin/articles/${id}`, data);
export const adminDeleteArticle = (id) => api.delete(`/admin/articles/${id}`);
export const getAdminPendingArticles = (params) => api.get('/admin/articles/pending', { params });
export const adminApproveArticle = (id) => api.put(`/admin/articles/${id}/approve`);
export const adminRejectArticle = (id, data) => api.put(`/admin/articles/${id}/reject`, data);
export const getAdminComments = (params) => api.get('/admin/comments', { params });
export const adminUpdateComment = (id, data) => api.put(`/admin/comments/${id}`, data);
export const adminDeleteComment = (id) => api.delete(`/admin/comments/${id}`);

export default api;
